export default __webpack_public_path__ + "static/media/roboto-v20-latin-700.2267169e.woff";